import { createContext, useContext, useState, useEffect } from 'react';
import { User, fetchUser } from '@services/users';
import { useAuthContext } from '@contexts/AuthContext';

interface UserContextType {
  user: User | undefined;
  loadingUser: boolean;
  setUser: (user: User) => void;
}

export const UserContext = createContext({} as UserContextType);

export function UserContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [user, setUser] = useState<User>();
  const [loadingUser, setLoadingUser] = useState(true);
  const { isAuthenticated, logout } = useAuthContext();

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    fetchUser()
      .then((response) => setUser(response))
      .catch((error) => {
        console.error(error);
        logout();
      })
      .finally(() => setLoadingUser(false));
  }, [isAuthenticated]);

  return (
    <UserContext.Provider value={{ user, loadingUser, setUser }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUserContext(): UserContextType {
  return useContext(UserContext);
}
